module.exports = __webpack_public_path__ + "img/caec690.jpg";